import { type ServiceMethod } from '@/application/interfaces/service';

export type Params = {
  cartId: string;
};

export type Body = {
  payment_method: 'credit_card' | 'pix' | 'bank_slip';
  credit_card?: {
    type: 'token';
    amount_installment: number;
    token: string;
    bin_suffix: string;
    brand: string;
    external_id: string;
  };
  value: number;
};

export type Data = Params & Body;

export type Response = {
  data: {
    id: string;
  };
};

const postPayment: ServiceMethod<Response, Data> =
  (httpClient) => async (data, options) => {
    const { cartId, payment_method, credit_card, value } = data;

    const { body: response } = await httpClient.post<Response, Body, Params>(
      '/api/v3/payment/{cartId}',
      {
        ...options,
        body: {
          payment_method,
          credit_card,
          value,
        },
        params: {
          cartId,
        },
      }
    );

    return response;
  };

export default postPayment;
